<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 40 40"
  >
    <path
      d="M21.5152 32H18.4848V13.8182L10.1515 22.1515L8 20L20 8L32 20L29.8485 22.1515L21.5152 13.8182V32Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconSend',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
